export default __webpack_public_path__ + "static/media/loader__image.3ae9c27d.gif";